<div class="alumni-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="alumni-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Institution Connect</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="alumni-shell">
      <aside class="alumni-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Alumni Menu</span>
          <h2>FMCET Alumni Relations</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="alumni-main">
        <section class="content-head-card">
          <span class="content-tag">Alumni Engagement</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/at.png"
                  alt="FMCET Alumni Relations"
                />
              </div>

              <div class="section-copy">
                <h3>About Alumni Relations</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>

                <ul class="feature-list">
                  <li *ngFor="let item of aboutHighlights">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </section>
          </ng-container>

          <!-- Pongal 2026 -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="content-card">
              <div class="section-head">
                <h3>ALUMNI PONGAL – 2026</h3>
                <p>Cultural celebration and alumni engagement event conducted on 13.01.2026.</p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of alumniPongal2026Paragraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card" *ngFor="let group of alumniPongal2026Groups">
              <div class="section-head">
                <h3>{{ group.title }}</h3>
                <p>{{ group.caption }}</p>
              </div>

              <div class="gallery-grid">
                <article class="gallery-card" *ngFor="let photo of group.photos">
                  <div class="gallery-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Meet 2024 -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>ALUMNI MEET – 2024</h3>
                <p>Grand alumni reunion and engagement programme conducted on 06.04.2024.</p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of alumniMeet2024Paragraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card" *ngFor="let group of alumniMeet2024Groups">
              <div class="section-head">
                <h3>{{ group.title }}</h3>
                <p>{{ group.caption }}</p>
              </div>

              <div class="gallery-grid">
                <article class="gallery-card" *ngFor="let photo of group.photos">
                  <div class="gallery-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Naming guide -->
   
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Alumni Office</span>
        <h3>Stay Connected with FMCET</h3>
        <p>
          Alumni In-Charge<br />
          M. Selvakumar, AP -  Mechanical<br />
          9894928839
        </p>
        <p>
          Alumni Relations Cell,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>

        <a class="text-link" href="mailto:info@fmcet.ac.in">
          info&#64;fmcet.ac.in
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Engagement</span>
        <h3>Celebrate, Reconnect, Inspire</h3>
        <p>
          Alumni events strengthen our tradition, community spirit, and lifelong
          bond with the institution.
        </p>
        <a routerLink="/contact" class="apply-button">
          Contact Us
        </a>
      </article>
    </section>
  </div>
</div>